<div class="p-8 flex flex-col gap-8">
    <h3>{{ config.data.title | translate }}</h3>
    <p class="m-0">{{ config.data.message | translate }}</p>
    <div class="flex flex-row justify-end gap-5">
        <sag-ui-button [color]="'secondary'" (click)="onClose()" ariaLabel="reject">{{config.data.reject | translate }}</sag-ui-button>
        <sag-ui-button (click)="onClose('Confirmed')" ariaLabel="accept">{{config.data.confirm | translate}}</sag-ui-button>
    </div>
</div>
